import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})

export class DashboardComponent implements OnInit, OnDestroy {

  constructor() { }

  public ngOnInit() {
  }

  public ngOnDestroy() {
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts